import useSourceFlowCollection from "@/hooks/useSourceFlowCollection";
import branches from "@/../.sourceflow/client_locations.json";

export const useBranches = ({ limit = null } = {}) => {
  const collection = useSourceFlowCollection(branches);

  if (limit) {
    return collection.slice(0, limit);
  }

  return collection;
};

export default useBranches;
